var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoader3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0ZM40 4.32432C59.7031 4.32432 75.6757 20.2969 75.6757 40C75.6757 59.7031 59.7031 75.6757 40 75.6757C20.2969 75.6757 4.32432 59.7031 4.32432 40C4.32432 20.2969 20.2969 4.32432 40 4.32432Z",
    fill: "#E5E5EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 0C62.0914 9.66516e-07 80 17.9086 80 40C80 62.0914 62.0914 80 40 80C17.9086 80 9.66391e-07 62.0914 0 40C0 17.9086 17.9086 0 40 0ZM40 4.32422C20.2969 4.32422 4.32422 20.2969 4.32422 40C4.32422 59.7031 20.2969 75.6758 40 75.6758C59.7031 75.6758 75.6758 59.7031 75.6758 40C75.6758 20.2969 59.7031 4.32422 40 4.32422Z",
    fill: "#33AB84"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7502 47.35L27.4002 40L24.9502 42.45L34.7502 52.25L55.7502 31.25L53.3002 28.8L34.7502 47.35Z",
    fill: "#33AB84"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader3);
export default __webpack_public_path__ + "static/media/loader #3.7409f662d2ccbf1a7d1bbcfb43619efa.svg";
export { ForwardRef as ReactComponent };